// Icons Material can be defined here, not fontAwesome

import {
  PicTreeReviewSummaryNtt,
  PicTreeReviewBudget,
  PicTreeReviewByAssetTypeNtt,
  PicTreeCheckInNtt,
  PicTreeMapNtt,
  PicTreeMissionSummary,
  PicTreeMissionRanking,
  // PicTreeReviewAppearance,
  PicTreeReportSummaryNtt,
  PicTreeReportCountByUsers,
  PicTreePhotoByArea,
} from "pages";

export default {
  items: [
    {
      path: "/game/pictree/ntt/photos/overview",
      name: "概要",
      type: "link",
      icon: false,
      category: "撮影",
      component: PicTreeReviewSummaryNtt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt/budget",
      name: "バジェット",
      type: "link",
      icon: false,
      component: PicTreeReviewBudget,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt/photos/asset-type",
      name: "アセットタイプ別",
      type: "link",
      icon: false,
      component: PicTreeReviewByAssetTypeNtt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt/photos/by-area",
      name: "エリア別",
      type: "link",
      icon: false,
      component: PicTreePhotoByArea,
      sideBar: true,
      divider: true,
    },
    {
      path: "/game/pictree/ntt/photos/map",
      name: "地図表示",
      type: "link",
      icon: false,
      component: PicTreeMapNtt,
      sideBar: true,
      divider: false,
    },
    // {
    //   path: "/game/pictree/ntt/photos/denchu/appearance",
    //   name: "出現回数",
    //   type: "link",
    //   icon: false,
    //   component: PicTreeReviewAppearance,
    //   sideBar: true,
    //   divider: false,
    // },
    {
      path: "/game/pictree/ntt/checkin",
      name: "チェックイン",
      type: "link",
      icon: false,
      component: PicTreeCheckInNtt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt/mission",
      name: "ミッションモード",
      type: "submenu",
      sideBar: true,
      children: [
        {
          path: "/overview",
          name: "概要",
          icon: null,
          component: PicTreeMissionSummary,
        },
        {
          path: "/ranking",
          name: "達成ランキング",
          icon: null,
          component: PicTreeMissionRanking,
        },
      ],
    },
    {
      path: "/game/pictree/ntt/report/overview",
      name: "概要",
      type: "link",
      icon: false,
      category: "報告",
      component: PicTreeReportSummaryNtt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt/report/report-by-user",
      name: "ユーザー別報告件数",
      type: "link",
      icon: false,
      component: PicTreeReportCountByUsers,
      sideBar: true,
      divider: false,
    },
  ],
};
